// extracted by mini-css-extract-plugin
module.exports = {"container":"categorizerSubRow__container___fiaGZ","list":"categorizerSubRow__list___2QNAz"};